// filter.js 文件
const VerifyStatusMap = { 0: '未审核', 1: '已通过', '-1': '已回退' }
const filterVerifyStatus = function (val) {
  return VerifyStatusMap[val] || '--'
}
// 状态 1 处理中 2 已答复 3 已办结
const statusMap = { 1: '处理中', 2: '已答复', 3: '已办结' }
const filterstatus = function (val) {
  return statusMap[val] || '--'
}
// 留言状态 1 处理中 2 已答复 3 已办结
const LYstatusMap = { 0: '待回复', 1: '已回复' }
const filterLYstatus = function (val) {
  return LYstatusMap[val] || '--'
}
// 性别 1男 0 女
const genderMap = ['女', '男']
const genderFilter = function (val) {
  return genderMap[val] || '--'
}
export { filterVerifyStatus, filterstatus, filterLYstatus, genderFilter } // 导出过滤函数
